import React, { useState } from 'react';

const PLANS = [
  {
    key: 'essential',
    name: 'Essential',
    monthly: 349, annual: 279,
    annualTotal: 3348,
    included: ['50 quotations per month','3 user seats','3 countries of your choice','30-day quote history','PDF & Excel export','Actual Tax engine'],
    excluded: ['Country comparison grid','Bulk & comparison export'],
    overage: 'Overage: $8 per 10 extra quotations',
  },
  {
    key: 'standard',
    name: 'Standard',
    monthly: 499, annual: 399,
    annualTotal: 4788,
    popular: true,
    included: ['200 quotations per month','10 user seats','All 8 countries','Unlimited quote history','PDF & Excel export','Actual Tax engine','Country comparison grid','Bulk & comparison export'],
    excluded: [],
    overage: 'Overage: $6 per 10 extra quotations',
  },
  {
    key: 'enterprise',
    name: 'Enterprise',
    custom: true,
    included: ['Unlimited quotations','Unlimited seats','All 8 countries + custom','Unlimited history','Everything in Standard','Dedicated account manager','White-label exports','SLA & priority support'],
    excluded: [],
    overage: 'No overage charges',
    dark: true,
  },
];

export default function Pricing() {
  const [annual, setAnnual] = useState(false);

  return (
    <section className="pricing" id="pricing">
      <div className="container">
        <div className="section-label">Pricing</div>
        <h2 className="section-title">Straightforward plans. No hidden costs.</h2>
        <p className="section-sub">Annual billing saves 20%. All plans include PDF and Excel exports. No setup fees.</p>

        <div className="pricing-toggle">
          <span className={`toggle-opt${!annual ? ' toggle-active' : ''}`}>Monthly</span>
          <button
            className="toggle-track"
            role="switch"
            aria-checked={annual}
            aria-label="Annual billing"
            onClick={() => setAnnual(a => !a)}
          >
            <span className="toggle-thumb" style={{ left: annual ? 23 : 3 }}/>
          </button>
          <span className={`toggle-opt${annual ? ' toggle-active' : ''}`}>
            Annual <span className="toggle-save">Save 20%</span>
          </span>
        </div>

        <div className="pricing-cards">
          {PLANS.map(plan => (
            <div
              key={plan.key}
              className={`pricing-card${plan.popular ? ' pricing-card--featured' : ''}${plan.dark ? ' pricing-card--enterprise' : ''}`}
            >
              {plan.popular && <div className="plan-badge">Most popular</div>}
              <div className="plan-name">{plan.name}</div>
              <div className="plan-price">
                <span className="plan-amount">
                  {plan.custom ? 'Custom' : `$${annual ? plan.annual : plan.monthly}`}
                </span>
                {!plan.custom && <span className="plan-period">/month</span>}
              </div>
              <div className="plan-billing">
                {plan.custom
                  ? 'Quoted by our team'
                  : annual
                    ? `Billed $${plan.annualTotal}/year`
                    : ''}
              </div>
              <ul className="plan-features">
                {plan.included.map(f => <li className="feat-yes" key={f}>{f}</li>)}
                {plan.excluded.map(f => <li className="feat-no"  key={f}>{f}</li>)}
              </ul>
              <div className="plan-overage">{plan.overage}</div>
              <a
                href="#contact"
                className={`btn-plan${plan.popular ? ' btn-plan--primary' : ''}`}
              >
                {plan.custom ? 'Talk to sales' : 'Get started'}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
